import { injectable, decorate, inject } from 'inversify';
import 'reflect-metadata';
import { SERVICE_IDENTIFIER } from 'constants/identifiers';
import { NetworkError, UserError } from 'errors';

@injectable()
class UserService {
  constructor(apiService) {
    this.apiService = apiService;
  }

  async getUser() {
    try {
      return await this.apiService.get('/user', {}, { withCredentials: true });
    } catch (e) {
      if (e instanceof NetworkError) {
        throw new UserError(e.message);
      }

      throw e;
    }
  }

  async getUserData() {
    const result = await this.apiService.get('/user', {}, { withCredentials: true });

    return result.data.data.items[0];
  }
}

decorate(inject(SERVICE_IDENTIFIER.ApiService), UserService, 0);

export default UserService;
